// src/store/store.auth.js
/* eslint-disable */
import { makeAuthPlugin } from '../feathers-client';

export default makeAuthPlugin({ userService: 'usuarios' });
